var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.52 14.25a9.44 9.44 0 0 0-.01-2.5l2.7-2.11c.24-.19.31-.55.16-.81L22.81 4.4a.65.65 0 0 0-.78-.3L18.84 5.4a9.42 9.42 0 0 0-2.16-1.26L16.2.75a.65.65 0 0 0-.64-.55h-5.12a.63.63 0 0 0-.63.55l-.48 3.38c-.78.32-1.5.76-2.16 1.26L4 4.1c-.3-.11-.63 0-.79.29L.65 8.83c-.16.28-.1.62.16.81l2.71 2.1a7.83 7.83 0 0 0-.03 2.51L.8 16.36a.65.65 0 0 0-.16.81l2.56 4.43c.16.3.49.39.78.3l3.19-1.29c.67.51 1.37.94 2.16 1.26l.48 3.38c.07.32.32.55.64.55h5.12c.32 0 .59-.23.63-.55l.48-3.38c.78-.32 1.5-.75 2.16-1.26L22 21.9c.3.11.63 0 .79-.29l2.56-4.43c.16-.29.1-.62-.16-.81l-2.68-2.1ZM13 17.8A4.81 4.81 0 0 1 8.2 13c0-2.64 2.16-4.8 4.8-4.8 2.64 0 4.8 2.16 4.8 4.8 0 2.64-2.16 4.8-4.8 4.8Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.34a0d534f0653440699e9096894882b5.svg";
export { ForwardRef as ReactComponent };